/**
 * Main Component
 * A React component that serves as the primary content area of the application
 * Manages the layout of sidebar menu, main content (via Outlet), and notifications
 */

import React from "react";
import SidebarMenu from "./sidebar-menu";
import { Outlet } from "react-router-dom";
import NotificationsContainer from "./notification-component/notifications-container";

/**
 * Main content component that structures the application's primary view
 * Composes the sidebar menu and main content area with notifications
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Current state of the sidebar menu
 * @param {Function} props.toggleSidebar - Function to toggle the sidebar state
 * @returns {JSX.Element} Rendered component with sidebar and main content area
 */
function Main({ isOpen, toggleSidebar }) {
  /**
   * Component render section
   * Renders a flex container with sidebar menu and main content area
   * Uses React Router's Outlet for dynamic content rendering
   */
  return (
    <main className="min-h-screen flex">
      {/* <SidebarMenu isOpen={isOpen} toggleSidebar={toggleSidebar} /> */}
      {/* <div className="flex-1 py-1 px-4"> */}
      <Outlet />
      <NotificationsContainer />
      {/* </div> */}
    </main>
  );
}

export default Main;
